<template>
    <div>
        <!-- alert modal -->
        <b-modal :id="modalAlert.id"
                 @hidden="onModalAlertHidden()"
                 modal-class="modal-alert"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <!-- <div class="modal-base-close" @click="clickCloseAlertModal()"></div> -->
                    <p>{{modalAlert.title}}</p>
                </div>
                <div class="modal-base-body">
                    <p>{{modalAlert.message}}</p>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-confirm" @click="clickOkModalAlert()">{{modalAlert.strBtnOk}}</button>
                </div>
            </div>
        </b-modal>

        <!-- alert Cancel modal -->
        <b-modal :id="modalAlertCancel.id"
                 @hidden="onModalAlertHidden()"
                 modal-class="modal-alert-cancel"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <!-- <div class="modal-base-close" @click="clickCloseAlertModal()"></div> -->
                    <p>{{modalAlertCancel.title}}</p>
                </div>
                <div class="modal-base-body">
                    <p>{{modalAlertCancel.message}}</p>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-confirm" @click="clickOkModalAlertCancel()">{{modalAlertCancel.strBtnOk}}</button>
                </div>
            </div>
        </b-modal>

        <!-- Thank modal -->
        <b-modal :id="modalThank.id"
                 @hidden="onModalAlertHidden()"
                 modal-class="modal-thank"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                 <div class="img-logo">
                    <img class="img-fluid" src="../../assets/icon/logo-popup@3x.png" />
                </div>
                <div class="modal-base-head">
                    <!-- <div class="modal-base-close" @click="clickCloseAddressModal()"></div> -->
                    <p>{{modalAlert.title}}</p>
                </div>
                <div class="modal-base-body">
                    <p>{{modalAlert.message}}</p>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-cancel" @click="clickOkModalThank()">{{modalAlert.strBtnOk}}</button>
                </div>
            </div>
        </b-modal>

        <!-- confirm modal -->
        <b-modal :id="modalConfirm.id"
                 @hidden="onModalConfirmHidden()"
                 modal-class="modal-confirm"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">

                <div class="modal-base-head">
                    <div class="modal-base-close" @click="clickCloseAddressModal()"></div>
                    <p>{{modalConfirm.title}}</p>
                </div>
                <div class="modal-base-body">
                    <p>{{modalConfirm.message}}</p>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-secondary" @click="clickCancelModalConfirm()">{{modalConfirm.strBtnCancel}}</button>
                    <button class="btn btn-primary ml-2" @click="clickOkModalConfirm()">{{modalConfirm.strBtnOk}}</button>
                </div>
            </div>
        </b-modal>

        <!-- Error Connect -->
        <b-modal :id="modalErrorConnect.id"
                @hidden="onModalAlertHidden()"
                modal-class="modal-alert-connect"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-body">
                    <img v-show="isShowLogo" src="@/assets/img/01-register/logo-big@2x.png" style="width:137px;margin:60px 0 20px 0" class="text-center">
                    <p v-html="modalAlert.message" ></p>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-secondary" @click="clickOkModalErrorConnect()">{{modalAlert.strBtnOk}}</button>
                </div>
            </div>
        </b-modal>

        <!-- loading modal -->
        <b-modal :id="modalLoading.id"
                 @hidden="onModalLoadingHidden()"
                 modal-class="modal-loading"
                 centered
                 hide-header
                 hide-footer>
                <img class="icon-loading" src="@/assets/icon/Eclipse-1s-200px.gif"/>
            <!-- <div class="modal-loading-content">

                Loading...
            </div> -->
        </b-modal>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';

/**
 * @property {string} view require - view unique name
 * @property {Vue} busModal optional - object for control modal
 *
 * Event callback
 * - alert
 * @event modalAlertOk
 * @event modalAlertHidden
 * - confirm
 * @event modalConfirmOk
 * @event modalConfirmCancel
 * @event modalConfirmHidden
 * - loading
 * @event modalLoadingHidden
 *
 * Call function by busModal event
 * - alert
 * @function showAlertModal
 * @function hideAlertModal
 * - confirm
 * @function showConfirmModal
 * @function hideConfirmModal
 * - loading
 * @function showLoadingModal
 * @function hideLoadingModal
 */
export default {
    name: "Modal",
    props: {
        view: String,
        busModal: Object,
        isShowLogo: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            modalAlert: {
                id: 'modal-alert-',
                title: '',
                strBtnOk: '',
                message: '',
                tag: '',
            },
            modalAlertCancel: {
                id: 'modal-alert-cancel',
                title: '',
                strBtnOk: '',
                message: '',
                tag: '',
            },
            modalThank: {
                id: 'modal-thank-',
                title: '',
                strBtnOk: '',
                message: '',
                tag: '',
            },
            modalConfirm: {
                id: 'modal-confirm-',
                title: '',
                strBtnOk: '',
                strBtnCancel: '',
                message: '',
                tag: '',
            },
            modalErrorConnect: {
                id: 'modal-error-connect',
                title: '',
                strBtnOk: '',
                strBtnCancel: '',
                message: '',
                tag: '',
            },
            modalLoading: {
                id: 'modal-loading-',
            },
        };
    },
    created: function() {
        this.modalAlert.id += this.view;
        this.modalAlertCancel.id += this.view;
        this.modalThank.id += this.view;
        this.modalConfirm.id += this.view;
        this.modalErrorConnect.id += this.view;
        this.modalLoading.id += this.view;
    },
    mounted: function() {
        this.busModal.$on('showAlertModal', this.showModalAlert);
        this.busModal.$on('hideAlertModal', this.hideModalAlert);

        this.busModal.$on('showAlertCancelModal', this.showModalAlertCancel);
        this.busModal.$on('hideAlertCancelModal', this.hideModalAlertCancel);

        this.busModal.$on('showThankModal', this.showModalThank);
        this.busModal.$on('hideThankModal', this.hideModalThank);

        this.busModal.$on('showConfirmModal', this.showModalConfirm);
        this.busModal.$on('hideConfirmModal', this.hideModalConfirm);

        this.busModal.$on('showErrorConnectModal', this.showErrorConnectModal);
        this.busModal.$on('hideErrorConnectModal', this.hideErrorConnectModal);

        this.busModal.$on('showLoadingModal', this.showModalLoading);
        this.busModal.$on('hideLoadingModal', this.hideModalLoading);


    },
    methods: {
        // === modal alert ===
        /**
         * @param {object} config - config modal
         * {
         *      title: '' ,     // Title text modal
         *      message: '',    // Message text modal
         *      strBtnOk: '',   // Button ok text modal (optional)
         *      tag: '',        // String modal tag name (optional)
         * }
         */
        showModalAlert: function(config) {
            this.modalAlert.title = config.title;
            this.modalAlert.message = config.message;
            this.modalAlert.strBtnOk = Util.isEmptyStr(config.strBtnOk) ? 'Ok' : config.strBtnOk;
            this.modalAlert.tag = config.tag;

            this.$bvModal.show(this.modalAlert.id);
        },
        hideModalAlert: function() {
            this.$bvModal.hide(this.modalAlert.id);
        },
        clickOkModalAlert: function() {
            this.hideModalAlert();
            this.$emit('modalAlertOk', { tag: this.modalAlert.tag });
        },
        onModalAlertHidden: function() {
            this.$emit('modalAlertHidden', { tag: this.modalAlert.tag });
        },
        clickCloseAlertModal: function() {
            this.hideModalAlert();
            this.$emit('modalAlertOk', { tag: this.modalAlert.tag });
        },

                // === modal alert Cancel ===
        /**
         * @param {object} config - config modal
         * {
         *      title: '' ,     // Title text modal
         *      message: '',    // Message text modal
         *      strBtnOk: '',   // Button ok text modal (optional)
         *      tag: '',        // String modal tag name (optional)
         * }
         */
        showModalAlertCancel: function(config) {
            this.modalAlertCancel.title = config.title;
            this.modalAlertCancel.message = config.message;
            this.modalAlertCancel.strBtnOk = Util.isEmptyStr(config.strBtnOk) ? 'Ok' : config.strBtnOk;
            this.modalAlertCancel.tag = config.tag;

            this.$bvModal.show(this.modalAlertCancel.id);
        },
        hideModalAlertCancel: function() {
            this.$bvModal.hide(this.modalAlertCancel.id);
        },
        clickOkModalAlertCancel: function() {
            this.hideModalAlertCancel();
            this.$emit('modalAlertCancelOk', { tag: this.modalAlertCancel.tag });
        },
        onModalAlertCancelHidden: function() {
            this.$emit('modalAlertCancelHidden', { tag: this.modalAlertCancel.tag });
        },
        clickCloseAlertCancelModal: function() {
            this.hideModalAlertCancel();
            this.$emit('modalAlertCancelOk', { tag: this.modalAlertCancel.tag });
        },

                // === modal thank ===
        /**
         * @param {object} config - config modal
         * {
         *      title: '' ,     // Title text modal
         *      message: '',    // Message text modal
         *      strBtnOk: '',   // Button ok text modal (optional)
         *      tag: '',        // String modal tag name (optional)
         * }
         */
        showModalThank: function(config) {
            this.modalAlert.title = config.title;
            this.modalAlert.message = config.message;
            this.modalAlert.strBtnOk = Util.isEmptyStr(config.strBtnOk) ? 'Ok' : config.strBtnOk;
            this.modalAlert.tag = config.tag;

            this.$bvModal.show(this.modalThank.id);
        },
        hideModalThank: function() {
            this.$bvModal.hide(this.modalThank.id);
        },
        clickOkModalThank: function() {
            this.hideModalThank();
            this.$emit('modalAlertOk', { tag: this.modalThank.tag });
        },
        onModalThankHidden: function() {
            this.$emit('modalAlertHidden', { tag: this.modalThank.tag });
        },

        // === modal confirm ===
        /**
         * @param {object} config - config modal
         * {
         *      title: '' ,         // Title text modal
         *      message: '',        // Message text modal
         *      strBtnOk: '',       // Button ok text modal (optional)
         *      strBtnCancel: '',   // Button cancel text modal (optional)
         *      tag: '',            // String modal tag name (optional)
         * }
         */
        showModalConfirm: function(config) {
            this.modalConfirm.title = config.title;
            this.modalConfirm.message = config.message;
            this.modalConfirm.strBtnOk = Util.isEmptyStr(config.strBtnOk) ? 'Ok' : config.strBtnOk;
            this.modalConfirm.strBtnCancel = Util.isEmptyStr(config.strBtnCancel) ? 'Cancel' : config.strBtnCancel;
            this.modalConfirm.tag = config.tag;

            this.$bvModal.show(this.modalConfirm.id);
        },
        hideModalConfirm: function() {
            this.$bvModal.hide(this.modalConfirm.id);
        },
        clickOkModalConfirm: function() {
            this.hideModalConfirm();
            this.$emit('modalConfirmOk', { tag: this.modalConfirm.tag });
        },
        clickCancelModalConfirm: function() {
            this.hideModalConfirm();
            this.$emit('modalConfirmCancel', { tag: this.modalConfirm.tag });
        },
        onModalConfirmHidden: function() {
            this.$emit('modalConfirmHidden', { tag: this.modalConfirm.tag });
        },

        //  Modal Error Connection

        showErrorConnectModal: function(config) {

            this.modalAlert.message = config.message;
            this.modalAlert.strBtnOk = Util.isEmptyStr(config.strBtnOk) ? 'Ok' : config.strBtnOk;

            this.$bvModal.show(this.modalErrorConnect.id);
        },
        hideErrorConnectModal: function() {
            this.$bvModal.hide(this.modalErrorConnect.id);
        },
        clickOkModalErrorConnect: function() {
            this.hideErrorConnectModal();
            this.$emit('modalAlertOk', { tag: this.modalErrorConnect.tag });
        },
        onModalErrorConnectHidden: function() {
            this.$emit('modalAlertHidden', { tag: this.modalErrorConnect.tag });
        },

        // === modal loading ===
        showModalLoading: function() {
            this.$bvModal.show(this.modalLoading.id);
        },
        hideModalLoading: function() {
            this.$bvModal.hide(this.modalLoading.id);
        },
        onModalLoadingHidden: function() {
            this.$emit('modalLoadingHidden');
        },
    },
}
</script>
<style lang="scss">
@import "@/style/base/component/modal/modal.scss";

</style>
